import React from 'react';

import CheckBox from '../../Default/CheckBox';

export default function ReactWhen({ respondToPlayerCollision, respondToObjectCollision, updateBlokStateActionReaction }) {
    return (
        <div className="side-bar-page-content">
            <div className="side-bar-row">
                <CheckBox
                    name="respondToPlayerCollision"
                    checked={respondToPlayerCollision}
                    onChange={() =>
                        updateBlokStateActionReaction({
                            respondToPlayerCollision: !respondToPlayerCollision
                        })
                    }
                >
                    Een speler tegen mij aan komt
                </CheckBox>
            </div>
            <div className="side-bar-row">
                <CheckBox
                    name="respondToObjectCollision"
                    checked={respondToObjectCollision}
                    onChange={() =>
                        updateBlokStateActionReaction({
                            respondToObjectCollision: !respondToObjectCollision
                        })
                    }
                >
                    Een vrij bewegend ding tegen mij aan komt
                </CheckBox>
            </div>
        </div>
    );
}
